/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendGetProjectDto } from '../../models/backend-get-project-dto';
import { BackendProjectConfigRequestDto } from '../../models/backend-project-config-request-dto';

export interface ProjectsProjectsCreate$Params {
  /**
   * Фильтр по IRR
   */
  irr_range?: string;

  /**
   * Фильтр по периоду окупаемости
   */
  payback_range?: string;

  /**
   * Фильтр по Рейтингу
   */
  rating_range?: string;
  body?: BackendProjectConfigRequestDto;
}

export function projectsProjectsCreate(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsProjectsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendGetProjectDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectsCreate.PATH, 'post');
  if (params) {
    rb.query('irr_range', params.irr_range, {});
    rb.query('payback_range', params.payback_range, {});
    rb.query('rating_range', params.rating_range, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendGetProjectDto>;
    }),
  );
}

projectsProjectsCreate.PATH = '/api/projects/projects/';
